export const ROLE_COLORS: Record<string, string> = {
  admin: '#EF4444',
  specialist: '#4A7EB5',
  salesman: '#10B981',
  estimator: '#F59E0B',
  foreman: '#EC4899',
  pm: '#8B5CF6',
  contracting_officer: '#06B6D4',
};

export const ROLE_LABELS: Record<string, string> = {
  admin: 'Admin',
  specialist: 'Roof Specialist',
  salesman: 'Salesman',
  estimator: 'Estimator',
  foreman: 'Foreman',
  pm: 'Production Manager',
  contracting_officer: 'Contracting Officer',
};

export function formatPhoneNumber(phone: string | null | undefined) {
  const value = phone?.trim();
  if (!value) return '—';
  const digits = value.replace(/\D/g, '');
  const nationalNumber = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
  if (nationalNumber.length !== 10) return value;
  return `(${nationalNumber.slice(0, 3)}) ${nationalNumber.slice(3, 6)}-${nationalNumber.slice(6)}`;
}
